import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const CardGuideTuto = ({ icon = null, content = "" }) => {
    return (
        <Wrapper fill column vAlign="center" hAlign="center">
            {icon}
            <Title content={content} />
        </Wrapper>
    );
};

export default CardGuideTuto;

const Title = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
`;

const Wrapper = styled(Flex)`
    padding: var(--spacing-l-24, 24px) 0px;
    gap: var(--spacing-ixxs-4, 4px);

    border-radius: var(--radius-l-8, 8px);
    background: var(
        --Light-theme-Rest-Background-Default-Background-1,
        #fafafa
    );
    cursor: pointer;
    :hover {
        background: var(
            --Light-theme-Rest-Background-Default-Background-1,
            rgb(238, 238, 238)
        );
    }
    /* shadow-2 */
    box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
        0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;
